
import axios from "axios";
import { OutputBaseProps } from "utils/types/API";
import { DataItemProps } from ".";

interface ApiDataFindByIdInputProps {
    formCode: string;
    id: number;
}

type ApiDataFindOutputProps = OutputBaseProps<{ item: DataItemProps; }, ApiDataFindByIdInputProps>

export const apiDataFindById = async ({ formCode, id }: ApiDataFindByIdInputProps) => {
    const res = (await axios.get<ApiDataFindOutputProps>(`/api/data/${formCode}/${id}`))
        .data;
    return res;
};


interface ApiDataIdFindByIdInputProps extends Omit<ApiDataFindByIdInputProps, "formCode"> {
    formId: number;
}
export const apiDataIdFindById = async ({ formId, id }: ApiDataIdFindByIdInputProps) => {
    const res = (await axios.get<ApiDataFindOutputProps>(`/api/data/id/${formId}/${id}`))
        .data;
    return res;
};